module.exports = __webpack_public_path__ + "public/images/geography.9acce842c5ebf09b1dee659cf978cb6c.png";